<a class="nav-link" matRipple>
    <mat-icon class="nav-link-icon" *ngIf="item.icon">{{ item.icon }}</mat-icon>
    <span class="nav-link-title">{{ item.title }}</span>
    <span class="nav-link-badge" *ngIf="item.badge" 
      [ngStyle]="{ 'background-color': item.badge.bg, 'color': item.badge.fg }">{{ item.badge.quantity }}</span>
    <mat-icon class="collapse-arrow">keyboard_arrow_right</mat-icon>
</a>

<div class="children" [@slideInOut]="isOpen">
    <ng-container *ngFor="let itemnav of item.children">
        <app-nav-horizontal-item *ngIf="itemnav.type === 'item'" [item]="itemnav"></app-nav-horizontal-item>
        <app-nav-horizontal-collapse *ngIf="itemnav.type === 'collapse'" [item]="itemnav"></app-nav-horizontal-collapse>
        <app-nav-horizontal-collapse *ngIf="itemnav.type == 'group'" [item]="itemnav"></app-nav-horizontal-collapse>
    </ng-container>
</div>